<app-title-section xmlns="http://www.w3.org/1999/html"></app-title-section>


<div class="card flex-grow mb-0" style="margin-left: 15px; margin-right: 15px;  background-color: transparent">

    <div class="content-area-wrapper " style=" gap: 16px">
        <!-- Sidebar Left -->
        <div class="card" style="width: 400px">
            <app-layout-steps-client
                    [steps]="steps"
                    [currentStep]="currentStep"
                    (goBack)="retour()"
                    (stepSelected)="onTimelineStepSelected($event)">

            </app-layout-steps-client>
        </div>

        <!-- Content Right -->
        <div class="card content-right custom-scroll" style="overflow: auto;">
            <div class="content-wrapper  p-0 content-right-r ">
                <div class="card-body ">
                    <div class="wizard-content ">
                        <div *ngIf="currentStep === 0 && mode === 'add'" class="step-form">

                            <div class="form-section rounded  d-flex">
                                <div class="option-card bordered pl-0"
                                     [ngClass]="{ 'selected': product.type === 'matériel',  'is-invalid': dataError.type }"
                                     (click)="selectType('matériel')">
                                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                                            <i data-feather="package" [size]="30" class="mb-1"></i>
                                            <span style="font-size: 15px">Matériel</span>
                                        </div>
                                        <label class="container">
                                            <input type="radio"
                                                   name="productType"
                                                   value="matériel"
                                                   [(ngModel)]="product.type"
                                                   (change)="validateStep1()"
                                                   class="form-check-input">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div *ngIf="dataError.type" class="invalid-feedback d-block mt-2 ml-0 p-0"
                                         style="text-align: justify;">
                                        {{ dataError.type }}
                                    </div>
                                </div>

                                <div class="option-card bordered"
                                     [ngClass]="{ 'selected': product.type === 'service', 'is-invalid': dataError.type }"
                                     (click)="selectType('service')">
                                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                                            <i data-feather="hard-drive" [size]="30" class="mb-1"></i>
                                            <span>Service</span>
                                        </div>
                                        <label class="container">
                                            <input type="radio"
                                                   name="productType"
                                                   value="service"
                                                   [(ngModel)]="product.type"
                                                   (change)="validateStep1()"
                                                   class="form-check-input">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>

                                <div class="option-card bordered"
                                     [ngClass]="{ 'selected': product.type === 'financier', 'is-invalid': dataError.type }"
                                     (click)="selectType('financier')">
                                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                                            <i data-feather="dollar-sign" [size]="30" class="mb-1"></i>
                                            <span>Financier</span>
                                        </div>
                                        <label class="container">
                                            <input type="radio"
                                                   name="productType"
                                                   value="financier"
                                                   [(ngModel)]="product.type"
                                                   (change)="validateStep1()"
                                                   class="form-check-input">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div class="d-flex justify-content-end mt-4">
                                <button (click)="handleStep1Continue()" class="btn btn-primary"
                                        style="height: 40px">
                                    Continuer
                                </button>
                            </div>
                        </div>

                        <div *ngIf="currentStep === 1" class=" ">
                            <div class=" rounded p-2 border-style step-form">
                                <h6 class=" mb-2 size15" style="color: #2F2B3DE5"><b> Informations principales </b></h6>

                                <div class="" style="margin-bottom: 24px">
                                    <label class="form-label size15">Nom du produit <span
                                            class="text-danger"> *</span></label>
                                    <input type="text" class="form-control" placeholder="Entrez Nom Produit"
                                           style="width: 433px"
                                           #nomRef="ngModel" [(ngModel)]="product.nom" name="productName"
                                           [ngClass]="{ 'is-invalid': dataError.nom }" [required]="!productData"
                                           (input)="clearFieldError('nom')"/>
                                    <div *ngIf="dataError.nom" class="invalid-feedback d-block">
                                        {{ dataError.nom }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center " style="gap: 50px; margin-bottom: 24px; ">
                                    <div class="tva">
                                        <label class="form-label  size15" style="color: #2F2B3DB2">TVA <span
                                                class="text-danger"> *</span></label>
                                        <div class="form-check form-check-inline" style="gap: 32px">
                                            <select style="height: 40px; width: 109px" class="form-control"
                                                    [(ngModel)]="product.tva_id"
                                                    name="productTva"
                                                    [ngClass]="{ 'is-invalid': dataError.tva }"
                                                    (change)="clearFieldError('tva') ; onTvaChange()">

                                                <option *ngFor="let tva of tva" [ngValue]="tva.id">
                                                    {{ tva.valeur }} %
                                                </option>
                                            </select>
                                            <button class="add-button" (click)="addtva('tva')">
                                                <i data-feather="plus" [size]="18"></i>
                                            </button>
                                        </div>
                                        <div *ngIf="dataError.tva" class="invalid-feedback d-block">
                                            {{ dataError.tva }}
                                        </div>
                                    </div>

                                    <div>
                                        <label class="form-label size15" style="color: #2F2B3DB2">Taxes</label>

                                        <div class="items2"
                                             style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;">
                                            <div *ngFor="let taxe of taxes"
                                                 class="check-border"
                                                 [class.selected]="isTaxeSelected(taxe.id)">
                                                <div class="custom-control custom-checkbox">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            [id]="'taxe-' + taxe.id"
                                                            [checked]="isTaxeSelected(taxe.id)"
                                                            (change)="toggleTaxe(taxe, $event.target.checked)"
                                                    />

                                                    <label class="custom-control-label" [for]="'taxe-' + taxe.id">
                                                        {{ taxe.nom }}
                                                    </label>
                                                </div>
                                            </div>


                                            <button class="add-button" (click)="addTaxes()">
                                                <i data-feather="plus" [size]="18"></i>
                                            </button>
                                        </div>

                                    </div>


                                </div>
                                <div class=" " style="margin-bottom: 24px">

                                    <div class="items4">
                                        <div class="row mb-2">
                                            <!--  <div class="col-lg-4">
                                                  <label>Prix d'achat <span class="text-danger">*</span></label>
                                                  <input type="number" class="form-control" min="0"
                                                         [(ngModel)]="product.prix_unitaires"
                                                         (input)="onPrixAchatChange(); clearFieldError('prix_unitaires')"
                                                         [ngClass]="{ 'is-invalid': dataError.prix_unitaires }"
                                                         placeholder="Entrez votre Prix d'achat"/>
                                                  <div *ngIf="dataError.prix_unitaires"
                                                       class="invalid-feedback d-block">
                                                      {{ dataError.prix_unitaires }}
                                                  </div>
                                              </div>

                                              <div class="col-lg-4">
                                                  <label class="size13">Marge bénéficiaire (%) <span
                                                          class="text-danger">*</span></label>
                                                  <input type="number" class="form-control" min="0"
                                                         [(ngModel)]="margePourcentage"
                                                         (input)="onMargeChange()"
                                                         [disabled]="!product.prix_unitaires"
                                                         [ngClass]="{ 'is-invalid': dataError.prix_unitaires }"
                                                         (change)="clearFieldError('marge')"
                                                         placeholder="Entrez votre Marge en %">
                                                  <div *ngIf="dataError.prix_unitaires"
                                                       class="invalid-feedback d-block">
                                                      {{ dataError.marge }} %
                                                  </div>
                                              </div>

                                              <div class="col-lg-4">
                                                  <label>Prix de vente <span class="text-danger">*</span></label>
                                                  <input type="number" class="form-control" min="0"
                                                         [(ngModel)]="prixVente"
                                                         (input)="onPrixVenteChange()"
                                                         [disabled]="!product.prix_unitaires"
                                                         [ngClass]="{ 'is-invalid': dataError.prix_unitaires }"
                                                         (change)="clearFieldError('prix_vente')"
                                                         placeholder="Entrez votre Prix de vente">
                                                  <div *ngIf="dataError.prix_unitaires"
                                                       class="invalid-feedback d-block">
                                                      {{ dataError.prix_vente }}
                                                  </div>
                                              </div>-->
                                            <div class="col-lg-4">
                                                <label>Prix de vente <span class="text-danger">*</span></label>
                                                <input type="number" class="form-control input-prix-keyboard-only" min="0" style="width: 433px"
                                                       [(ngModel)]="product.prix_unitaires"
                                                       (input)="onPrixAchatChange(); clearFieldError('prix_unitaires')"
                                                       (wheel)="$event.preventDefault()"
                                                       (keydown)="preventNumberInputArrows($event)"
                                                       [ngClass]="{ 'is-invalid': dataError.prix_unitaires }"
                                                       placeholder="Entrez votre Prix d'achat"/>
                                                <div *ngIf="dataError.prix_unitaires"
                                                     class="invalid-feedback d-block">
                                                    {{ dataError.prix_vente }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row ml-0">
                                            <label class="tva-box"
                                                   [class.selected]="priceType === 'HT'"
                                                   style="padding-left: 9px; padding-bottom: 6px;">
                                                <div>
                                                    <label class="container">
                                                        <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="priceType"
                                                                value="HT"
                                                                [(ngModel)]="priceType"
                                                                (change)="calculateFinalPrice()"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <span style="margin-top: 9px; font-size: 15px">HT</span>
                                            </label>

                                            <div class="mr-2" style="margin-top: 8px;">
    <span class="mx-1 size15" style="color: #134AD3">
        {{ product.result_ht | number:'1.2-2' }} DT
    </span>
                                            </div>

                                            <label class="tva-box"
                                                   [class.selected]="priceType === 'TTC'"
                                                   style="padding-left: 9px; padding-bottom: 6px;">
                                                <div>
                                                    <label class="container">
                                                        <input
                                                                class="tva-radio"
                                                                type="radio"
                                                                name="priceType"
                                                                value="TTC"
                                                                [(ngModel)]="priceType"
                                                                (change)="calculateFinalPrice()"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <span style="margin-top: 9px; font-size: 15px">TTC</span>
                                            </label>
                                            <div style="margin-top: 8px;">
                                            <span class="mx-1 size15 "
                                                  style="color: #134AD3">{{ product.result_ttc | number:'1.2-2' }}
                                                DT</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="product" class="d-flex" style="gap: 30px">
                                    <div class="custom-control custom-checkbox mb-1">
                                        <input type="checkbox"
                                               [(ngModel)]="product.autoriser_vente_stock_vide"
                                               name="autoriser_vente_stock_vide"
                                               class="custom-control-input"
                                               [id]="'check-stock-' + uniqueId"/> <label class="custom-control-label"
                                                                                         [for]="'check-stock-' + uniqueId"> Autoriser la vente lorsque le stock est vide
                                    </label>
                                    </div>

                                    <div class="custom-control custom-checkbox mb-3">
                                        <input type="checkbox"
                                               [(ngModel)]="product.produit_avec_numero_serie"
                                               name="produit_avec_numero_serie"
                                               class="custom-control-input"
                                               [id]="'check-serial-' + uniqueId"/> <label class="custom-control-label"
                                                                                          [for]="'check-serial-' + uniqueId"> Produit avec numéro de série
                                    </label>
                                    </div>
                                </div>


                                <label class=" size15" style="margin-bottom: 20px; color: #2F2B3DE5">
                                    <b> Liste de prix </b> </label>

                                <div style="margin-bottom: 34px">


                                    <div *ngFor="let price of priceLists; let i = index" class="price-block ">
                                        <!-- Liste de prix -->
                                        <div class="mb-3 mt-3 " *ngIf="i >= 1 "
                                             style="border-top: 1px solid #134AD3; width: 350px"></div>
                                        <div class="" style="margin-bottom: 30px">

                                            <div class="items2" style="height: 80px">

                                                <div>
                                                    <label class="form-label size13" style="width: 100px">
                                                        Type <span *ngIf="price.selectedPriceId || price.montant"
                                                                   class="text-danger">*</span></label>
                                                    <select
                                                            style=" height: 40px"
                                                            class="form-control "
                                                            [(ngModel)]="price.selectedPriceId"
                                                            name="priceSelect{{ i }}"
                                                            [ngClass]="{ 'is-invalid': dataError.list }"
                                                            (input)="clearFieldError('list')"
                                                            (change)="onPriceSelected(i, price.selectedPriceId)"
                                                    >
                                                        <option [ngValue]="null">-- Sélectionner un type --</option>
                                                        <option *ngFor="let type of availablePriceLists"
                                                                [ngValue]="type.id">
                                                            {{ type.libelle }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- base de calcul et Règles -->
                                                <div class=" items " style="margin-bottom: 24px">
                                                    <div>
                                                        <label class="mb-1 form-label size15">Base de calcul
                                                            <span *ngIf="price.selectedPriceId || price.montant"
                                                                  class="text-danger">*</span></label>
                                                        <div class="form-check form-check-inline">
                                                            <div>
                                                                <label class="container">
                                                                    <input type="radio"
                                                                           id="prixpub{{ i }}"
                                                                           (input)="clearFieldError('bascul_calcul')"
                                                                           (change)="onBaseCalculChange(i)"
                                                                           name="bascul_group{{ i }}"
                                                                           value="prix_public"
                                                                           [(ngModel)]="price.bascul_calcul"
                                                                           [ngClass]="{ 'is-invalid': dataError.bascul_calcul }"
                                                                           class="form-check-input">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <!--      <input [ngClass]="{ 'is-invalid': dataError.bascul_calcul }"
                                                                         type="radio" class="form-check-input"
                                                                         id="prixpub{{ i }}"
                                                                         (input)="clearFieldError('bascul_calcul')"
                                                                         (change)="onBaseCalculChange(i)"
                                                                         name="bascul_group{{ i }}" value="prix_public"
                                                                         [(ngModel)]="price.bascul_calcul"/> -->
                                                            <label class="form-check-label size15" style="width: 100px"
                                                                   for="prixpub{{ i }}">Prix
                                                                publique</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <div>
                                                                <label class="container">
                                                                    <input type="radio" class="form-check-input"
                                                                           (input)="clearFieldError('bascul_calcul')"
                                                                           (change)="onBaseCalculChange(i)"
                                                                           [(ngModel)]="price.bascul_calcul"
                                                                           name="bascul_group{{ i }}"
                                                                           value="arbitraires"
                                                                           id="arbitraire{{ i }}"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>

                                                            <label class="form-check-label size15"
                                                                   for="arbitraire{{ i }}">Arbitraire</label>
                                                        </div>
                                                        <div *ngIf="dataError.bascul_calcul"
                                                             class="invalid-feedback d-block">
                                                            {{ dataError.bascul_calcul }}
                                                        </div>
                                                    </div>
                                                    <div *ngIf="price.bascul_calcul !== 'arbitraires'">
                                                        <label class="mb-1 form-label size15">
                                                            Règles <span *ngIf="price.selectedPriceId || price.montant"
                                                                         class="text-danger">*</span></label>
                                                        <div class="form-check form-check-inline">
                                                            <div>
                                                                <label class="container">
                                                                    <input type="radio" class="form-check-input"
                                                                           id="fix{{ i }}"
                                                                           [ngClass]="{ 'is-invalid': dataError.regle }"
                                                                           (input)="clearFieldError('regle')"
                                                                           (change)="onBaseCalculChange(i)"
                                                                           [(ngModel)]="price.regles"
                                                                           name="rule_group{{ i }}" value="fixe"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>

                                                            <label class="form-check-label size15"
                                                                   for="fix{{ i }}">Fixe</label>
                                                        </div>

                                                        <div class="form-check form-check-inline">
                                                            <div>
                                                                <label class="container">
                                                                    <input type="radio" class="form-check-input"
                                                                           id="percent{{ i }}"
                                                                           (input)="clearFieldError('regle')"
                                                                           (change)="onBaseCalculChange(i)"
                                                                           [(ngModel)]="price.regles"
                                                                           name="rule_group{{ i }}"
                                                                           value="pourcentage"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>

                                                            <label class="form-check-label size15" for="percent{{ i }}">Pourcentage</label>
                                                        </div>
                                                        <div *ngIf="dataError.regle" class="invalid-feedback d-block">
                                                            {{ dataError.regle }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <button class="minus-button mt-2"
                                                        *ngIf="(price.selectedPriceId || price.montant) || (priceLists.length > 1 || hasAddedPrice)"
                                                        (click)="onMinusClick(i, price)"
                                                        [disabled]="priceLists.length <= 1 && !(price.selectedPriceId || price.montant)"
                                                        title="Supprimer / Annuler"
                                                >
                                                    <i data-feather="minus" [size]="16"></i>
                                                </button>

                                                <!--  <button *ngIf="price.selectedPriceId || price.montant"
                                                            class="minus-button mt-2"
                                                            (click)="clearPriceListSelection(i)"
                                                            style="background: #e3342f; color: white;"
                                                            title="Annuler la sélection"
                                                    >
                                                        X
                                                    </button>
                                                    <button class="minus-button mt-2"
                                                            (click)="removePriceList(i)"
                                                            *ngIf="priceLists.length > 1 || hasAddedPrice"
                                                            [disabled]="priceLists.length <=1"
                                                    >
                                                        <i [size]="16" data-feather="minus"></i>
                                                    </button> -->

                                            </div>
                                            <div *ngIf="dataError.list" class="invalid-feedback d-block">
                                                {{ dataError.list }}
                                            </div>
                                        </div>


                                        <!-- Montant & Résultat -->
                                        <div class="d-flex items2 align-items-center "
                                             style="gap: 60px; margin-bottom: 24px">
                                            <div class="">
                                                <label class="form-label"
                                                       *ngIf=" price.regles !=='pourcentage' || price.bascul_calcul === 'arbitraires'">
                                                    Montant <span *ngIf="price.selectedPriceId || price.montant "
                                                                  class="text-danger">*</span>


                                                </label>
                                                <!-- Indication pour pourcentage -->
                                                <label class="form-label" *ngIf="price.regles === 'pourcentage'">
                                                    Pourcentage % <span *ngIf="price.selectedPriceId || price.montant "
                                                                        class="text-danger">*</span>
                                                </label>
                                                <div class="custom-input-container">
                                                    <button class="minus-button-left"
                                                            (click)="decrementAmount(i)">-
                                                    </button>

                                                    <input style="border-radius: 0px" type="number"
                                                           class="form-control text-center"
                                                           [ngClass]="{ 'is-invalid': dataError.montant }"
                                                           (input)="clearFieldError('montant'); calculateResults(i)"
                                                           [(ngModel)]="price.montant" name="amount-{{i}}"/>

                                                    <button class="minus-button-right"
                                                            (click)="incrementAmount(i)">+
                                                    </button>

                                                </div>

                                                <div *ngIf="dataError.montant" class="invalid-feedback d-block">
                                                    {{ dataError.montant }}
                                                </div>
                                            </div>
                                            <div>
                                                <label class="form-label">Résultat</label>

                                                <!-- Sélecteur HT/TTC pour Arbitraire -->
                                                <div *ngIf="price.bascul_calcul === 'arbitraires'" class="row ml-0 ">
                                                    <label class="tva-box"
                                                           style=" padding-left: 9px; padding-bottom: 6px;">
                                                        <div>
                                                            <label class="container">
                                                                <input
                                                                        class="tva-radio"
                                                                        type="radio"
                                                                        [name]="'arbitraryPriceType' + i"
                                                                        value="HT"
                                                                        [(ngModel)]="priceType2"
                                                                        (change)="onArbitraryPriceTypeChange(i)"
                                                                />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <span style="margin-top: 9px; font-size: 15px">HT</span>
                                                    </label>
                                                    <div class="mr-2" style="margin-top: 8px;">
                                                    <span class="mx-2 size15"
                                                          style="color: #134AD3">{{ price.result_ht | number:'1.2-2' }}
                                                        DT</span>
                                                    </div>

                                                    <label class="tva-box"
                                                           style=" padding-left: 9px; padding-bottom: 6px;">
                                                        <div>
                                                            <label class="container">
                                                                <input
                                                                        class="tva-radio"
                                                                        type="radio"
                                                                        [name]="'arbitraryPriceType' + i"
                                                                        value="TTC"
                                                                        [(ngModel)]="priceType2"
                                                                        (change)="onArbitraryPriceTypeChange(i)"
                                                                />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <span style="margin-top: 9px; font-size: 15px">TTC</span>
                                                    </label>
                                                    <div style="margin-top: 8px;">
                                                    <span class="mx-2 size15"
                                                          style="color: #134AD3">{{ price.result_ttc | number:'1.2-2' }}
                                                        DT</span>
                                                    </div>
                                                </div>

                                                <!-- Affichage simple pour Prix Public -->
                                                <div *ngIf="price.bascul_calcul === 'prix_public'" class="d-flex "
                                                     style="gap: 22px">
                                                    <div class="d-flex">
                                                        <div class="result-box">{{ (price.result_ht || 0) | number:'1.2-2' }}
                                                            DT
                                                        </div>
                                                        <span class="ttc">HT</span>
                                                    </div>
                                                    <div class="d-flex">

                                                        <div class="result-box">{{ (price.result_ttc || 0) | number:'1.2-2' }}
                                                            DT
                                                        </div>
                                                        <span class="ttc mr-1">TTC</span>
                                                    </div>

                                                </div>

                                                <!-- Affichage par défaut quand rien n'est sélectionné -->
                                                <div *ngIf="!price.bascul_calcul" class="d-flex " style="gap: 22px">
                                                    <div class="d-flex">
                                                        <div class="result-box">0.00 DT</div>
                                                        <span class="ttc">HT</span>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div class="result-box">0.00 DT</div>
                                                        <span class="ttc mr-1">TTC</span>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Bouton ajouter -->
                                    <a class="text-primary " style="margin-bottom: 4px"
                                       (click)="addPriceList()"><strong>Ajouter un nouveau prix</strong></a>
                                </div>
                                <h6 *ngIf="productType === 'matériel'" class="mt-2 mb-2 size15"
                                    style="color: #2F2B3DE5"><b> Informations logistiques </b></h6>

                                <div *ngIf="productType === 'matériel'" class="mb-2">
                                    <div *ngFor="let warehouse of warehouses; let i = index"
                                         class="">
                                        <div class="mb-3 mt-3" *ngIf="i >= 1 "
                                             style="border-top: 1px solid #134AD3; width: 268px"></div>
                                        <div class="items2 mb-2">
                                            <!-- Entrepôt -->
                                            <div>
                                                <label class="size13">Entrepôt <span class="text-danger"
                                                                                     *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                                </label>
                                                <select style="width: 268px; height: 40px" class="form-control"
                                                        [ngClass]="{ 'is-invalid': dataError.entrepot }"
                                                        (input)="clearFieldError('entrepot')"
                                                        [(ngModel)]="warehouse.entrepot_id"
                                                        name="warehouse-{{i}}">
                                                    <option *ngFor="let entrepot of allEntrepot"
                                                            [ngValue]="entrepot.id">
                                                        {{ entrepot.nom }}
                                                    </option>
                                                </select>
                                                <div *ngIf="dataError.entrepot"
                                                     class="invalid-feedback d-block">
                                                    {{ dataError.entrepot }}
                                                </div>
                                            </div>

                                            <!-- Minimum -->
                                            <div>
                                                <label class="size13">
                                                    Minimum <span class="text-danger"
                                                                  *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                                </label>
                                                <div class="custom-input-container">
                                                    <button class="minus-button-left" (click)="decrement(i)"
                                                            [disabled]="warehouse.minimum <= 0">-
                                                    </button>
                                                    <input style="border-radius: 0px"
                                                           type="number"
                                                           min="0"
                                                           class="form-control text-center"
                                                           name="minStock-{{i}}"
                                                           [(ngModel)]="warehouse.minimum"
                                                           (keydown)="preventNegativeInput($event)"
                                                           (input)="clearFieldError('min'); ensurePositiveValue(warehouse, 'minimum')"
                                                           (blur)="ensurePositiveValue(warehouse, 'minimum')"
                                                           [ngClass]="{ 'is-invalid': dataError.min }"
                                                    />

                                                    <button class="minus-button-right" (click)="increment(i)">
                                                        +
                                                    </button>
                                                </div>
                                                <div *ngIf="dataError.min"
                                                     class="invalid-feedback d-block">
                                                    {{ dataError.min }}
                                                </div>
                                            </div>

                                            <!-- Maximum -->
                                            <div>
                                                <label class="size13">
                                                    Maximum <span class="text-danger"
                                                                  *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                                </label>
                                                <div class="custom-input-container">
                                                    <button class="minus-button-left" (click)="decrementMax(i)"
                                                            [disabled]="warehouse.maximum <= 0">-
                                                    </button>
                                                    <input style="border-radius: 0px"
                                                           type="number" min="0"
                                                           class="form-control text-center"
                                                           name="maxStock-{{i}}"
                                                           [(ngModel)]="warehouse.maximum"
                                                           (input)="clearFieldError('max'); ensurePositiveValue(warehouse, 'maximum')"
                                                           (blur)="ensurePositiveValue(warehouse, 'maximum')"
                                                           [ngClass]="{ 'is-invalid': dataError.max }"


                                                    />

                                                    <button class="minus-button-right"
                                                            (click)="incrementMax(i)">+
                                                    </button>

                                                    <!-- Bouton supprimer
                                                    <button style="margin-left: 7px" type="button"
                                                            class="minus-button"
                                                            *ngIf="warehouses.length >1"
                                                            [disabled]="warehouses.length <= 1"
                                                            (click)="removeWarehouse(i)">
                                                        <i [size]="16" data-feather="minus"></i>
                                                    </button>

                                                    <button *ngIf="warehouse.entrepot_id || warehouse.minimum || warehouse.maximum"
                                                            class="minus-button ml-2"
                                                            (click)="clearWarehouseListSelection(i)"
                                                            style="background: #e3342f; color: white;"
                                                            title="Annuler la sélection"
                                                    >
                                                        X
                                                    </button> -->
                                                    <button
                                                            class="minus-button ml-2"
                                                            *ngIf="(warehouse.entrepot_id || warehouse.minimum || warehouse.maximum) || warehouses.length > 1"
                                                            (click)="onWarehouseMinusClick(i, warehouse)"
                                                            [disabled]="warehouses.length <= 1 && !(warehouse.entrepot_id || warehouse.minimum || warehouse.maximum)"
                                                            title="Supprimer / Annuler"
                                                    >
                                                        <i data-feather="minus" [size]="16"></i>
                                                    </button>

                                                </div>
                                                <div *ngIf="dataError.max"
                                                     class="invalid-feedback d-block">
                                                    {{ dataError.max }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" mx-1 custom-control custom-checkbox "
                                             style="margin-bottom: 24px">
                                            <!-- Coché = désactiver l'alerte (is_active_alert false) -->
                                            <input type="checkbox" class="custom-control-input"
                                                   [id]="'customCheck3-' + i"
                                                   [name]="'warehouse-is-active-alert-' + i"
                                                   [ngModel]="!warehouse.is_active_alert"
                                                   (ngModelChange)="warehouse.is_active_alert = !$event"/>
                                            <label class=" custom-control-label" [attr.for]="'customCheck3-' + i">Désactiver l'alerte lorsque le stock est vide</label>
                                        </div>
                                    </div>
                                    <a (click)="addWarehouse()" class="text-primary"> <strong> Ajouter un
                                        entrepot </strong></a>
                                </div>


                            </div>
                            <div class="d-flex justify-content-between mt-3">
                                <button class="retour-btn" (click)="goBack()">
                                    <i class="bi bi-arrow-left me-1 "> </i>
                                    <i class="bx bx-arrow-back"></i> Retour
                                </button>
                                <div class="d-flex buttonsep">
                                    <button *ngIf="mode === 'edit'" type="button" (click)="quickUpdate()"
                                            class="btn btn-outline-primary"> Mettre à jour rapidement
                                    </button>
                                    <button class="btn btn-primary" (click)="handleStepCompletion(1)">Continuer</button>
                                </div>
                            </div>
                        </div>


                        <div *ngIf="currentStep === 2" class="step-form">

                            <ng-container>
                                <div class="p-2 border-style">
                                    <div class="col-lg-12">

                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="logo-card" (click)="logoInput.click()">
                                                <ng-container *ngIf="!logoPreview">


                                                    <div class="logo-upload-text">
                                                        <div style="color: #134AD3" class="mb-2">
                                                            <i [size]="25" data-feather="image"></i>
                                                        </div>
                                                        <p>Ajoutez une image du produit</p>
                                                        <p class="size13" style="color: #2F2B3DB2">La limite de
                                                            l’image est de 1
                                                            Megabyte</p>
                                                        <button style="color: #134AD3" class="unstyled-btn"
                                                                (click)="fileInput.click(); $event.stopPropagation()">
                                                            <input type="file" accept="image/*" hidden
                                                                   (change)="onFileSelected($event)"
                                                                   #fileInput/>
                                                            <i [size]="24" data-feather="download"></i>

                                                        </button>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="logoPreview">
                                                    <img [src]="logoPreview" alt="Logo choisi"/>
                                                </ng-container>
                                                <input
                                                        type="file"
                                                        #logoInput
                                                        class="custom-file-input"
                                                        accept="image/*"
                                                        (change)="onFileSelected($event)"

                                                />
                                                <div class="invalid-feedback d-block" *ngIf="dataError.logo">
                                                    {{ dataError.logo }}
                                                </div>

                                            </div>
                                        </div>

                                        <div class="col-lg-8">
                                            <label *ngIf="productType=='matériel'">Marque</label>

                                            <div *ngIf="productType=='matériel'" class="mb-2 items2">

                                                <select style="height: 40px" class="form-control"
                                                        [(ngModel)]="product.marque_id" name="productMarque">
                                                    <option *ngFor="let marque of marques" [ngValue]="marque.id">
                                                        {{ marque.libelle }}
                                                    </option>
                                                </select>
                                                <button class="add-button" (click)="addMarque(stationId)"><i
                                                        data-feather="plus" [size]="18"></i></button>
                                            </div>

                                            <label> Catégories </label>
                                            <div class="mb-2 items2">
                                                <select style="height: 40px" class="form-control"
                                                        [(ngModel)]="product.categories_id" name="productCategory">
                                                    <option *ngFor="let category of categories"
                                                            [ngValue]="category.id">
                                                        {{ category.libelle }}
                                                    </option>
                                                </select>
                                                <button class="add-button" (click)="addCategory(stationId)">
                                                    <i data-feather="plus" [size]="18"></i>
                                                </button>
                                            </div>
                                            <label>Unité</label>
                                            <div class="mb-2 items2">
                                                <select style="height: 40px" class="form-control"
                                                        [(ngModel)]="product.unite_id" name="productUnite">
                                                    <option *ngFor="let unite of unites" [ngValue]="unite.id">
                                                        {{ unite.libelle }}
                                                    </option>
                                                </select>
                                                <button class="add-button" (click)="addUnite(stationId)">
                                                    <i data-feather="plus" [size]="18"></i>
                                                </button>
                                            </div>
                                            <div class="row" *ngIf="productType=='service' || productType=='financier'">
                                                <div [ngClass]="shouldShowCodeBarreInput() ? 'col-lg-4' : 'col-lg-6'">
                                                    <label>Référence interne <span class="text-danger">*</span></label>
                                                    <input type="text"
                                                           class="form-control"
                                                           placeholder="Entrez la référence interne"
                                                           [ngClass]="{ 'is-invalid': dataError.ref }"
                                                           [(ngModel)]="product.ref_interne"
                                                           (input)="clearFieldError('ref')"
                                                           name="refInterneService"
                                                    />
                                                    <div *ngIf="(productType === 'service' || productType === 'financier') && dataError.ref"
                                                         class="invalid-feedback d-block">
                                                        {{ dataError.ref }}
                                                    </div>
                                                </div>
                                                <div [ngClass]="shouldShowCodeBarreInput() ? 'col-lg-4' : 'col-lg-6'">
                                                    <label>Référence fabricant <span class="text-danger">*</span></label>
                                                    <input type="text"
                                                           class="form-control"
                                                           placeholder="Entrez la référence fabricant"
                                                           [ngClass]="{ 'is-invalid': dataError.refFabricant }"
                                                           [(ngModel)]="product.ref_fabricant"
                                                           (input)="clearFieldError('refFabricant')"
                                                           name="refFabricantService"
                                                    />
                                                    <div *ngIf="dataError.refFabricant" class="invalid-feedback d-block">
                                                        {{ dataError.refFabricant }}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4" *ngIf="shouldShowCodeBarreInput()">
                                                    <label>Code-barres <span class="text-danger">*</span></label>
                                                    <input type="text"
                                                           class="form-control"
                                                           placeholder="Entrez le code-barres"
                                                           [ngClass]="{ 'is-invalid': dataError.codeBarre }"
                                                           [(ngModel)]="product.code_barre"
                                                           (input)="clearFieldError('codeBarre')"
                                                           name="codeBarreService"
                                                    />
                                                    <div *ngIf="dataError.codeBarre" class="invalid-feedback d-block">
                                                        {{ dataError.codeBarre }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <br><br>

                                    <div class="row mb-2">
                                        <div *ngIf="productType=='matériel'"
                                             [ngClass]="shouldShowCodeBarreInput() ? 'col-lg-4' : 'col-lg-6'">
                                            <label>Référence interne <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control"
                                                   placeholder="Entrez votre Référence interne"
                                                   [ngClass]="{ 'is-invalid': dataError.ref }"
                                                   (input)="clearFieldError('ref')"
                                                   [(ngModel)]="product.ref_interne" name="refInterneMat"/>
                                            <div *ngIf="dataError.ref" class="invalid-feedback d-block">
                                                {{ dataError.ref }}
                                            </div>
                                        </div>
                                        <div *ngIf="productType=='matériel'"
                                             [ngClass]="shouldShowCodeBarreInput() ? 'col-lg-4' : 'col-lg-6'">
                                            <label>Référence fabricant <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control"
                                                   placeholder="Entrez votre Référence fabricant"
                                                   [ngClass]="{ 'is-invalid': dataError.refFabricant }"
                                                   [(ngModel)]="product.ref_fabricant"
                                                   (input)="clearFieldError('refFabricant')"
                                                   name="refFabricantMat"
                                            />
                                            <div *ngIf="dataError.refFabricant" class="invalid-feedback d-block">
                                                {{ dataError.refFabricant }}
                                            </div>
                                        </div>
                                        <div *ngIf="productType=='matériel' && shouldShowCodeBarreInput()" class="col-lg-4">
                                            <label>Code-barres <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control"
                                                   placeholder="Entrez le code-barres"
                                                   [ngClass]="{ 'is-invalid': dataError.codeBarre }"
                                                   [(ngModel)]="product.code_barre"
                                                   (input)="clearFieldError('codeBarre')"
                                                   name="codeBarreMat"
                                            />
                                            <div *ngIf="dataError.codeBarre" class="invalid-feedback d-block">
                                                {{ dataError.codeBarre }}
                                            </div>
                                        </div>
                                    </div>

                                    <label for="description" class=" p-1 size13">Description</label>

                                    <textarea id="description" [(ngModel)]="product.description"
                                              style="margin-right: 14px"
                                              class="form-control"
                                              placeholder="Saisissez une description"></textarea>

                                </div>

                                <div class="d-flex justify-content-between mt-2">
                                    <button (click)="goBack()" class="retour-btn "><i
                                            class="bi bi-arrow-left me-2"> </i> Retour
                                    </button>
                                    <button *ngIf="mode === 'add'" (click)="handleStepCompletion(2)"
                                            class="btn btn-primary">Valider
                                    </button>
                                    <button *ngIf="mode === 'edit'" (click)="handleStepCompletion(2)"
                                            class="btn btn-primary">Mettre à jour
                                    </button>
                                </div>

                            </ng-container>
                        </div>

                        <!-- Étape : Paramètres des données (GET param-tables products) -->
                        <div *ngIf="currentStep === 3" class="step-form add-product-param-data-step">
                            <div class="p-2 border-style">
                                <h6 class="mb-3 size15" style="color: #2F2B3DE5"><b>Paramètres des données</b></h6>
                                <p class="size13 mb-3" style="color: #6E6B7B">
                                    Champs personnalisés pour les produits.
                                </p>
                                <div *ngIf="paramTablesLoading" class="text-muted mb-2">Chargement…</div>
                                <div
                                        *ngFor="let row of paramTableRows; let i = index"
                                        class="add-product-param-row mb-3">
                                    <label class="form-label size13 mb-1 d-block">{{ row.libelle }}</label>
                                    <ng2-flatpickr
                                            *ngIf="row.type === 'date'"
                                            class="add-product-param-date w-100"
                                            [name]="'paramValeurDate' + i"
                                            [config]="paramDateFlatpickrOptions"
                                            [(ngModel)]="row.valeur"
                                            (ngModelChange)="onParamDateValeurChange(row, $event)"
                                            placeholder="jj/mm/aaaa"
                                    ></ng2-flatpickr>
                                    <ng-select
                                            *ngIf="row.type === 'select'"
                                            class="ng-select-custom w-100"
                                            [inputId]="'paramValeurSelect' + i"
                                            [items]="getParamSelectOptions(row.param_table_id)"
                                            bindLabel="label"
                                            bindValue="value"
                                            [(ngModel)]="row.valeur"
                                            [name]="'paramValeurSelect' + i"
                                            [clearable]="true"
                                            placeholder="Choisir une option"
                                            [notFoundText]="'Aucune option'"
                                    ></ng-select>
                                    <input
                                            *ngIf="row.type !== 'date' && row.type !== 'select'"
                                            type="text"
                                            class="form-control"
                                            [(ngModel)]="row.valeur"
                                            [name]="'paramValeur' + i"
                                            placeholder="Valeur"
                                            autocomplete="off">
                                </div>

                            </div>
                            <div class="d-flex justify-content-between mt-2">
                                <button (click)="goBack()" class="retour-btn">
                                    <i class="bi bi-arrow-left me-2"></i> Retour
                                </button>
                                <div class="d-flex buttonsep" style="gap: 8px;">
                                    <button *ngIf="mode === 'add'" type="button" (click)="handleStepCompletion(3)"
                                            class="btn btn-primary">Valider
                                    </button>
                                    <button *ngIf="mode === 'edit'" type="button" (click)="handleEditStepCompletion(3)"
                                            class="btn btn-primary">Mettre à jour
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="currentStep === 4" class="step-form">
                            <div class=" step-4-success text-center border-style ">
                                <div class="success-icon ">

                                    <i class="bi bi-check2-all text-success" style="font-size: 80px;"></i>
                                </div>
                                <h3 class="mb-3"
                                    style="font-size: 18px"> {{ mode === 'edit' ? 'Produit mis à jour avec succès' : 'Produit ajouté avec succès' }}</h3>

                                <div class="d-flex center justify-content-center" style="gap: 24px">
                                    <button *ngIf="mode === 'add'" (click)="addNewProduct()"
                                            class="btn btn-outline-primary m-0">Ajouter Un Nouveau Produit
                                    </button>
                                    <button *ngIf="mode === 'edit'" routerLink="/produits-services/ajout-produit"
                                            class="btn btn-outline-primary m-0">Ajouter Un Nouveau Produit
                                    </button>
                                    <button (click)="detail()" class="btn btn-primary m-0">Voir Produit</button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
</div>

<app-add-taxe #addtaxe></app-add-taxe>
